<template>
  <div style="display: inline-block">
    <span v-if="!needHidden">{{ realText }}</span>
    <el-tooltip v-else :content="realText" placement="top-start">
      <span class="hidden-text">{{ shortText }}...</span>
    </el-tooltip>
  </div>
</template>
<script>
import { cutStrByFullLength, getStrFullLength } from './util';
export default {
  props: {
    length: {
      type: Number,
      default: 20
    },
    texts: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      shortText: '',
      realText: ''
    };
  },
  computed: {
    needHidden() {
      const str = this.texts;
      const fullLength = getStrFullLength(str);
      this.shortText = cutStrByFullLength(str, this.length);
      this.realText = str;
      return this.length < fullLength;
    }
  }
};
</script>
<style lang="less" scoped>
.hidden-text {
  cursor: pointer;
}
</style>